import { CompanyStructure } from "@wingspanhq/users/dist/lib/interfaces";

export const selectorNo1099CompanyStructure = (
  companyStructure: CompanyStructure
) =>
  companyStructure === CompanyStructure.CorporationS ||
  companyStructure === CompanyStructure.CorporationC ||
  companyStructure === CompanyStructure.LLCCorporationS ||
  companyStructure === CompanyStructure.LLCCorporationC;
